import { object, string } from 'yup';
import { REGULAR_EXPRESSIONS } from '../constants/regex';

const EmailValidationMessage = 'please enter a valid email';

export const userSignUpSchema = object().shape({
  email: string().required().email(EmailValidationMessage),
  firstName: string().required('please enter first name'),
  lastName: string().required('please enter last name'),
  phoneNumber: string().required('please enter phone number'),
  password: string()
    .required('please enter the password')
    .test('Validity', 'please enter at least 5 characters', (value) => {
      if (value) {
        return value?.length >= 5;
      }
      return false;
    }),
  confirmPassword: string()
    .required()
    .test('Validity', 'please enter at least 5 characters', (value) => {
      if (value) {
        return value?.length >= 5;
      }
      return false;
    }),
});

export const userSignInSchema = object().shape({
  email: string().required().email(EmailValidationMessage),
  password: string()
    .required('please enter the password')
    .test('Validity', 'please enter at least 5 characters', (value) => {
      if (value) {
        return value?.length >= 5;
      }
      return false;
    }),
});

export const forgotPasswordSchema = object().shape({
  email: string()
    .required('please enter an email')
    .email(EmailValidationMessage),
});

export const emailSchema = string()
  .matches(REGULAR_EXPRESSIONS.EMAIL)
  .email(EmailValidationMessage);
